module.exports = __webpack_public_path__ + "media/images/emblems/Willisau_Stadt_LU-308410a570fdc63e52965877f827f8f2.png";